import { Component } from '@angular/core';
import { EdiSendStatusComponent } from 'gung-standard';

@Component({
  selector: 'otto-olsen-edi-send-status',
  templateUrl: './otto-olsen-edi-send-status.component.html',
  styleUrl: './otto-olsen-edi-send-status.component.scss',
  standalone: false
})
export class OttoOlsenEdiSendStatusComponent extends EdiSendStatusComponent {}
